import React from "react";
import { Button, DatePicker, Form, Input, Select, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import Heading from "../../../Components/Heading/Heading";
import {
  useAddReservationCollectionMutation,
  useGetBranchesQuery,
  useGetCustomersQuery,
  useGetReservationsQuery,
  useGetSellersQuery,
  useLazyGetCustomerReservationsQuery,
} from "../../../redux/Service/api";
import CustomerReservationsDetails from "./CustomerReservationsDetails";

const { Option } = Select;

const CollectReservation: React.FC = () => {
  const [form] = Form.useForm();

  const { data: branchesData } = useGetBranchesQuery(undefined);
  const { data: sellersData } = useGetSellersQuery(undefined);
  const { data: customersData } = useGetCustomersQuery(undefined);

  const [addReservationCollection, { isLoading }] =
    useAddReservationCollectionMutation();

  const branches = branchesData?.ResponseObject || [];
  const sellers = sellersData?.ResponseObject || [];
  const customers = customersData?.ResponseObject || [];

  const [getData, { data: customerReservationsData, isFetching }] =
    useLazyGetCustomerReservationsQuery();
  const customerReservations = customerReservationsData?.ResponseObject || [];

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        BranchId: values.BranchId,
        DocDate: values.DocDate.format("YYYY-MM-DDT00:00:00"),
        Notes: values.Notes,
        FinCashDets: [
          {
            SideType: 0,
            SideId: values.CustomerId,
            Value: values.Value,
            ValueTafqit: values.ValueTafqit,
            // CurrId: 1,
            CurrRate: 1,
            SafeType: 0,
            ReserveId: values.ReserveId,
            // SafeId: 1,
            SellerId: values.SellerId,
            // CostID: "",
            Notes: values.DetailNotes,
          },
        ],
      };

      const response = await addReservationCollection(requestBody);
      if (response?.data) {
        message.success("تم تحصيل الحجز بنجاح");
        form.resetFields();
      }
    } catch (error) {
      console.error("Error collecting reservation:", error);
      message.error("Failed to collect reservation. Please try again.");
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
    message.error("Please complete all required fields.");
  };

  return (
    <div>
      <Heading heading="تحصيل حجز" />
      <div className="container grid grid-cols-1 gap-0">
        <Form
          form={form}
          name="collectReservation"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="form-grid"
        >
          <Form.Item
            label="العميل"
            name="CustomerId"
            rules={[{ required: true, message: "يرجى اختيار العميل" }]}
          >
            <Select
              size="large"
              placeholder="اختر العميل"
              showSearch
              onChange={(e) => {
                getData(e);
              }}
            >
              {customers?.map((customer: any) => (
                <Option key={customer.CustomerID} value={customer.CustomerID}>
                  {customer.CustomerName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="رقم الحجز"
            name="ReserveId"
            rules={[{ required: true, message: "يرجى اختيار رقم الحجز" }]}
          >
            <Select
              size="large"
              placeholder="اختر رقم الحجز"
              showSearch
              className="min-w-[200px]"
              loading={isFetching}
            >
              {customerReservations?.map((reservation: any) => (
                <Option
                  key={reservation.ReserveID}
                  value={reservation.ReserveID}
                >
                  {reservation.ReserveID}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="الفرع"
            name="BranchId"
            rules={[{ required: true, message: "يرجى اختيار الفرع" }]}
          >
            <Select size="large" placeholder="اختر الفرع">
              {branches.map((branch: any) => (
                <Option key={branch.BranchID} value={branch.BranchID}>
                  {branch.BranchName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="تاريخ المستند"
            name="DocDate"
            rules={[{ required: true, message: "يرجى اختيار تاريخ المستند" }]}
          >
            <DatePicker size="large" className="w-full" />
          </Form.Item>

          <Form.Item
            label="القيمة"
            name="Value"
            rules={[{ required: true, message: "يرجى إدخال القيمة" }]}
          >
            <Input size="large" type="number" />
          </Form.Item>

          <Form.Item
            label="القيمة التفقيطية"
            name="ValueTafqit"
            rules={[{ required: true, message: "يرجى إدخال القيمة التفقيطية" }]}
          >
            <Input size="large" placeholder="" />
          </Form.Item>

          <Form.Item
            label="مندوب تحصيل"
            name="SellerId"
            rules={[{ required: true, message: "يرجى اختيار مندوب تحصيل" }]}
          >
            <Select size="large" placeholder="اختر مندوب تحصيل">
              {sellers.map((seller: any) => (
                <Option key={seller.SellerID} value={seller.SellerID}>
                  {seller.SellerName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="ملاحظات" name="Notes">
            <TextArea size="large" rows={2} />
          </Form.Item>

          <Form.Item label="ملاحظات تفصيلية" name="DetailNotes">
            <TextArea size="large" rows={2} />
          </Form.Item>

          <div className="flex items-center">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isLoading}
            >
              حفظ
            </Button>
          </div>
        </Form>

        <CustomerReservationsDetails customers={customers} />
      </div>
    </div>
  );
};

export default CollectReservation;
